import { z } from 'zod';
/**
 * Field schemas several contract files share, so a limit changes in one place for every request
 * that uses it. The admin portal builds its form rules from the same schemas.
 */
/** A lowercase exam-pack key such as `ssc_cgl` or `tier1`. */
export const PackKey = z
    .string()
    .regex(/^[a-z][a-z0-9_]*$/)
    .max(64);
/** An ISO date-time with an explicit offset. */
export const IsoDateTime = z.iso.datetime({ offset: true });
/** An exam key such as `ssc_cgl` (questions, jobs and schedules). */
export const ExamKey = z.string().trim().min(1).max(40);
/** Why an admin took an action (kept in the audit log). */
export const AdminReason = z.string().trim().min(3).max(500);
/** A dot-separated topic path such as `quant.arithmetic.percentage`. */
export const TopicPath = z
    .string()
    .max(200)
    .regex(/^[a-z0-9_]+(\.[a-z0-9_]+)*$/, 'A topic path like quant.arithmetic.percentage');
/** A column name in an uploaded CSV or spreadsheet. */
export const TableColumn = z.string().min(1).max(200);
/** An admin's sign-in email. Trimmed, so a pasted trailing space still signs in. */
export const AdminEmail = z.string().trim().max(254).pipe(z.email());
/** The password an admin types to prove who they are (any existing password). */
export const CurrentPassword = z.string().min(1).max(256);
/** A new admin password. */
export const NewPassword = z.string().min(12, 'Use at least 12 characters').max(128);
/** A public https link (the only scheme Telegram and the importers accept). */
export const HttpsUrl = z
    .url({ protocol: /^https$/, error: 'Enter a full https:// link' })
    .max(2048);
/** A public web page or feed (http or https). */
export const WebUrl = z
    .url({ protocol: /^https?$/, error: 'Enter a full http:// or https:// link' })
    .max(2000);
/** A student search: name, @username or Telegram id. */
export const StudentSearch = z.string().trim().max(80);
/** An OpenRouter model slug: `provider/model`, e.g. `openai/gpt-4.1-mini`. */
export const ModelSlug = z
    .string()
    .trim()
    .min(3)
    .max(200)
    .regex(/^[a-z0-9][a-z0-9._-]*\/[A-Za-z0-9][A-Za-z0-9._:-]*$/, 'Use provider/model, e.g. openai/gpt-4.1-mini');
//# sourceMappingURL=fields.js.map